import { render } from "./Tick.vue?vue&type=template&id=cd521316"
const script = {}
script.render = render

export default script